export default {
  availabilityFlagForQueue: (
    localState,
    localGetters,
    { auth: { userConfigs } },
  ) => {
    return userConfigs?.flagHabilitarFilaAtendimento || false;
  },
};
